import React, { useState } from "react";
import { Box, Button, Dialog, DialogTitle, Grid, styled } from "@mui/material";

export interface trafficCheckModalProps {
    props: {
        checkPoint: string;
        modalOpen: boolean;
        setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
        handleModalClose: any;
    };
}

const CancelButton = styled(Button)({
    backgroundColor: "#ffffff00",
    color: "#f00",
    border: "1px solid #f00",
    float: "left",
    margin: "10px 20px",
});

const TrafficCheckModal: React.FC<trafficCheckModalProps> = ({ props }) => {
    // 通行量項目チェックモーダルを閉じる
    const handleModalClose = () => {
        props.setModalOpen(false);

        switch (props.checkPoint) {
            case "saveAndDulicate":  //調査書 右上メニュー 保存ボタンと複製ボタン
                props.handleModalClose.save();
                props.handleModalClose.dulicate();
                break;
            case "addTraffic":       //通行量 追加ボタン
                props.handleModalClose.addTraffic();
                break;
            case "longPageRequest":  //調査書 右下 依頼ボタン
                props.handleModalClose.longPageRequest();
                break;
            default:
                break;
        }    
    };

    return (

        <Box>
            <Dialog open={props.modalOpen} onClose={handleModalClose}>
                <Box>
                    <DialogTitle sx={{ textAlign: "center" }}>
                        通行量で各項目を入力してください
                    </DialogTitle>
                    <Box sx={{ margin: "30px" }}>
                        <Grid container spacing={1} alignItems="center">
                            <Grid
                                item
                                xs={12}
                                sx={{ display: "flex", justifyContent: "center" }}
                            >
                                <CancelButton
                                    onClick={() => {
                                        handleModalClose();
                                    }}
                                >
                                    閉じる
                                </CancelButton>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Dialog>
        </Box>
    );
};

export default TrafficCheckModal;
